import React, { useState } from "react";
import { LivestreamLayoutCommonProps } from "../../../types";
import { LayoutHeader } from "../../layouts/LayoutHeader";
import { EventCard } from "../../event-card";
import { FilterOption } from "../../layouts-live-stream/ToggleFilter/ToggleFilter";
import { filterEventsByType } from "../../../libs/utils/eventFilter";
import { EmptyLiveStreams } from "../../empty-state";
import LayoutModal from "../../event-card/FullScreenModal";
import * as Styled from "./Layout1.styled";

export const Layout1: React.FC<LivestreamLayoutCommonProps & { columns?: number }> = ({
    events,
    sessionToken,
    isSignedIn,
    activePlans,
    hasFullAccess,
    freeTrialPlanIds,
    onWatchClick,
    columns,
}) => {
    const [selectedOption, setSelectedOption] = useState<FilterOption>("All");
    const [showSeeAll, setShowSeeAll] = useState(false);

    const filteredEvents = filterEventsByType(events, selectedOption);

    if (!events.length) return <EmptyLiveStreams />;

    return (
        <>
            <LayoutHeader
                title={"Live Streams"}
                itemCount={filteredEvents?.length}
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
                onSeeAll={() => setShowSeeAll(true)}
                padding="20px 10px 20px 0px"
                marginTop="0px"
                showToggle={true}
                isLivestream={true}
                isMobile={true}
            />
            {filteredEvents.length === 0 ? (
                <EmptyLiveStreams
                    showHeader={false}
                    isFiltered={selectedOption !== "All"}
                />
            ) : (
                <Styled.MobileGrid columns={columns}>
                    {filteredEvents.map((item) => (
                        <EventCard
                            event={item}
                            isSignedIn={isSignedIn}
                            hasEligiblePlan={
                                isSignedIn &&
                                (!!item.planDetails.length
                                    ? !!activePlans.filter((memberPlan) =>
                                          item.planDetails?.some(
                                              (itemPlan: any) =>
                                                  itemPlan?.id === memberPlan.id
                                          )
                                      ).length ||
                                      freeTrialPlanIds.includes(
                                          item.planDetails[0]?.id
                                      ) ||
                                      hasFullAccess
                                    : true)
                            }
                            onWatchClick={onWatchClick}
                            key={item.id}
                        />
                    ))}
                </Styled.MobileGrid>
            )}

            <LayoutModal
                show={showSeeAll}
                onHide={() => setShowSeeAll(false)}
                filteredLiveEvents={events}
                isSignedIn={isSignedIn}
                activePlans={activePlans}
                hasFullAccess={hasFullAccess}
                freeTrialPlanIds={freeTrialPlanIds}
                onWatchClick={onWatchClick}
                isMobile={true}
            />
        </>
    );
};
